import 'slick-carousel/slick/slick.js';

$('[data-slick]').removeClass('d-none').slick({})
$('button[data-bs-toggle="tab"][data-has-slider]').on('shown.bs.tab', function (e) {
    $(e.target.dataset.bsTarget).find('[data-slick]').slick('setPosition')
})